// Monotonic z-index allocator for modals.
//
// Each call returns a strictly larger number than the previous call. Top-level
// modals call this whenever they open (or re-key) so the most recently opened
// modal always sits above older ones — no manual stack bookkeeping required.
// See `useAutoZ` in ModalStackContext.js for the consumer hook.

let counter = 1300;
export const allocateZ = () => (counter += 10);
